import { createSelector } from 'reselect'

import { LandingStatus } from 'partner360/models/landing/LandingStatus'

import { selectLandingState } from './selectLandingState'

export const selectLandingStatuses = createSelector(
  [selectLandingState],
  ({ selectedPlanning }) => {
    return selectedPlanning.AllStatuses.split(',') as LandingStatus[]
  }
)
